import { createFileRoute } from '@tanstack/react-router';
import ForgotPassword from 'containers/Login/ForgotPassword';
import { AppLoader } from '../-components/AppLoader';

export const Route = createFileRoute('/login/forgotPassword')({
  validateSearch: (search: Record<string, unknown>): { userName?: string } => ({
    userName: typeof search.userName === 'string' ? search.userName : undefined,
  }),
  pendingComponent: AppLoader,
  component: ForgotPassword,
});
